module.exports = __webpack_public_path__ + "img/sonylogo.ffc5caa0.png";